import { type ChunkMetaInput } from '../../persistenceV2';
import {
  type SessionChunk,
  type SessionRecordingConfig,
  type SessionRecordingStore,
} from '../../types';

/** zustand StateCreator closure params, for v2 handlers living outside the slices. */
export type SetState = (
  partial:
    | Partial<SessionRecordingStore>
    | ((state: SessionRecordingStore) => Partial<SessionRecordingStore>)
) => void;

export type GetState = () => SessionRecordingStore;

/** Config is set at hydrate before any pipeline work — a miss is a wiring bug, fail loud. */
export const requireConfig = (get: GetState): SessionRecordingConfig => {
  const { config } = get();
  if (!config)
    throw new Error('SessionRecordingStore config not set before pipeline work');
  return config;
};

export const chunkMeta = (chunk: SessionChunk): ChunkMetaInput => ({
  sessionId: chunk.sessionId,
  recordingId: chunk.recordingId,
  index: chunk.index,
  id: chunk.id,
  size: chunk.size,
  duration: chunk.duration,
  producedAt: chunk.producedAt ?? 0,
});
